export default {
  metaTitle: 'Kilimall E-commerce Cloud - 商品促销报名',
  pageTitle1: '促销活动',
  pageTitle2: '商品报名',
  pageTitle3: '活动信息摘要',
  activity1: '活动展示名',
  activity2: '促销类型',
  activity3: '满',
  activity4: '减',
  activity5: '活动起始时间',
  activity6: '至',
  activity7: '抵扣选项',
  activity8: '创建的时间',
  activity9: '报名信息',
  activity10: '请输入要报名的listingid，多个以逗号分隔',
  placeholder1: '请输入ListingID',
  btn: '检测',
  btn2: '提交报名',
  signUp: '以下商品报名失败',
  signUp2: '商品ID',
  signUp3: '消息',
  error1: '商品数不能超过30个,商品id为数字并且不能以逗号或空格开头或结尾',
  error2: '请使用英文逗号',
  columnListing1: 'Listing ID',
  columnListing2: '标题',
  columnListing3: '最低商品价',
  columnListing4: '最高商品价',
  columnListing5: 'SKU个数',
  columnListing6: '状态',
  columnListing7: '操作',
  status1: '下架',
  status2: '上架',
  remove: '移除',
  error5: '当前不可用',
  error6: '请先检测listing ID',
  error7: '请确保至少一个listing可用',
  error8: '请检测listing',
  content1: '确认报名吗'
}
